import { render } from "./InputSize.vue?vue&type=template&id=9fbb25b4&scoped=true"
import script from "./InputSize.vue?vue&type=script&lang=js"
export * from "./InputSize.vue?vue&type=script&lang=js"

import "./InputSize.vue?vue&type=style&index=0&id=9fbb25b4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbb25b4"]])

export default __exports__